import * as React from "react";
import classNames from "classnames";
import {
	WithStyles,
	Theme,
	createStyles,
	withStyles,
} from "@material-ui/core";
import { connect } from "react-redux";
import { ConnectedSheet } from "../sheet";
import Typography from "@material-ui/core/Typography";
import { ConnectedPaymentList } from './payment-table';

type Props = WithStyles<typeof styles>;

export class PaymentOverview extends React.Component<Props> {
	public render() {
		const { classes } = this.props;

		return (
			<ConnectedSheet maxWidth={1200} contentClass={classes.sheetContent}>
				<Typography className={classes.sectionTitle}>
					Zahlungen
				</Typography>
				<ConnectedPaymentList />
			</ConnectedSheet>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		sectionTitle: {
			fontSize: "1.2rem",
			fontWeight: 500,
			marginBottom: 10
		},
		sheetContent: {
			padding: 2
		}
	});

export const ConnectedPaymentOverview = withStyles(styles)(PaymentOverview);
